const WORDS = [
  "PRECISIONE ASSOLUTA",
  "STAMPA FDM / PLA",
  "FILE STL",
  "PICCOLI LOTTI",
  "PROTOTIPI RAPIDI",
  "SU MISURA",
];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div
      data-testid="marquee"
      className="relative py-10 border-y border-white/10 bg-[#0A0E14] overflow-hidden"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-black text-4xl md:text-6xl stroke-text px-8">
              {w}
            </span>
            <span className="text-[#F5871F] text-3xl">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
